import LeftOutlined from "@ant-design/icons/LeftOutlined";
import { Col, Row } from "antd";
import React from "react";
import footer from "../../images/tiq-footer-logo.png";
import footerRight from "../../images/Etiqa-logo.png";
import "./footer.css";
import moment from 'moment';

function renderLastLoginTime(value){
  if(value && moment(value).isValid()){
    let momentTime = moment(value).format("DD/MMM/YYYY HH:mm:ss A")
    return "Last Logged In on " + momentTime;
  }else{
    return;
  }
}

class Footer2 extends React.PureComponent {
  render() {
    return (
      <div className="footer">
        <div className="footer-container">
          <Row>
            <Col xs={24} md={12} className="copyright-image">
              <a href="https://tiq.com.sg/">
                <img src={footer} alt="logo" className="logo-image" />
              </a>                
            </Col>
            <Col xs={24} md={12} className="footer-right">
              <div className="copyright-text">
                <img src={footerRight} alt="etiqa-logo" className="logo-image2"/>
              </div>
              <div className="copyright-text">
                © 2022 ETIQA INSURANCE PTE LTD. All rights reserved.
              </div>
              <div className="copyright-text">
                UEN: 201331905K
              </div>
              <div className="copyright-text">
                <small>
                  {renderLastLoginTime(localStorage.getItem("LastLoginTime"))}
                </small>
              </div>
            </Col>
          </Row>
        </div>
        <br />
      </div>
    );
  }
}

export default Footer2;
